import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const CTA = () => {
  const navigate = useNavigate();

  return (
    <section className="py-32 bg-gradient-to-br from-primary via-primary/90 to-accent/80 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,_hsl(var(--accent)/0.15),transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,_hsl(var(--primary)/0.2),transparent_50%)]" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-10">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full text-primary-foreground font-semibold border border-white/20 mb-4">
            <span className="w-2 h-2 bg-accent rounded-full animate-pulse"></span>
            <span>Launching Q2 2026</span>
          </div>

          <h2 className="text-5xl md:text-6xl font-bold text-primary-foreground leading-tight animate-fade-in">
            Ready to Make a Change?
          </h2>
          
          <p className="text-2xl text-primary-foreground/95 leading-relaxed max-w-2xl mx-auto">
            Join thousands of job seekers and forward-thinking employers creating second-chance success stories.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto">
            <Input
              type="email"
              placeholder="Enter your email"
              className="bg-white/15 border-white/30 text-white placeholder:text-white/70 backdrop-blur-md h-14 text-lg focus:bg-white/25 focus:border-white/40 transition-all"
            />
            <Button 
              size="lg" 
              className="group shrink-0 h-14 px-8 text-lg shadow-[var(--shadow-elevated)] hover-scale bg-white text-primary hover:bg-white/95 font-semibold"
              onClick={() => navigate("/auth")}
            >
              Get Early Access
              <ArrowRight className="group-hover:translate-x-1 transition-transform ml-2" />
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-primary-foreground/90 pt-4">
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-accent" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>No credit card required</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-accent" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Free to get started</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-accent" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Privacy guaranteed</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
